import {BIModel} from './BIModel.js';

export class HomeDeliveryBIModel extends BIModel {

    static eventName = 'click';

    #userId;
    #action;

    constructor(userId, action) {
        super(HomeDeliveryBIModel.eventName, userId);

        this.#userId = userId;
        this.#action = action;
    }

    static createFromDomainEvent(userId, homeDeliveryEvent) {
        return new HomeDeliveryBIModel(
            userId,
            homeDeliveryEvent.action
        );
    }

    get userId() {
        return this.#userId;
    }

    get action() {
        return this.#action;
    }

    get modelData() {
        return {
            action: this.action
        };
    }

}